/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 12.05.2016.
 */

import Assets from './reducer-assets';

export default Assets;



// WEBPACK FOOTER //
// ./src/reducers/assets/index.js